// Vendor
import { ElementRef, model } from '@angular/core';
import { finalize } from 'rxjs/operators';
// Constants
import { INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE } from 'FoldersApp/apps/compliance-report-history-app/state/compliance-designation-type/compliance-designation-type.reducer';
import { INITIAL_COMPLIANCE_REPORT_TYPE_FILTER_STATE } from 'FoldersApp/apps/compliance-report-history-app/state/compliance-report-type/compliance-report-type.reducer';
import { ComplianceReportHistoryPageSortColumn } from 'FoldersApp/apps/compliance-report-history-app/constants';
import { COMPLIANCE_REPORT_HISTORY_PARAM_KEYS } from 'FoldersApp/apps/compliance-report-history-app/state/constants';
import { DESC } from 'NewAngular/constants/core.constants';
import { TODO_NOTIFICATION_TYPES, } from 'NotificationsApp/ts/features/notifications-side-menu/constants';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { ComplianceReportService } from 'FoldersApp/apps/compliance-report-history-app/services/compliance-report.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { NotificationsService } from 'NotificationsApp/ts/services/notifications.service';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "NotificationsApp/ts/services/notifications.service";
import * as i2 from "FoldersApp/apps/compliance-report-history-app/services/compliance-report.service";
import * as i3 from "AccountsApp/ts/services/accounts.service";
import * as i4 from "NewAngular/services/core/urls.service";
import * as i5 from "@angular/common";
import * as i6 from "NotificationsApp/ts/features/notifications-side-menu/components/notifications-menu-list-item/notifications-menu-list-item.component";
import * as i7 from "NotificationsApp/ts/features/notifications-side-menu/components/notifications-menu-report-history-item/notifications-menu-report-history-item.component";
const _c0 = ["regionsContainer"];
const _c1 = a0 => ({ "flex": a0 });
const _c2 = a0 => ({ active: a0 });
const _c3 = () => [];
const _forTrack0 = ($index, $item) => $item.id;
function NotificationsSideMenuComponent_table_17_tr_2_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 24);
    i0.ɵɵlistener("removeNotification", function NotificationsSideMenuComponent_table_17_tr_2_Template_tr_removeNotification_0_listener($event) { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.removeNotification($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r4 = ctx.$implicit;
    i0.ɵɵproperty("notification", notification_r4);
} }
function NotificationsSideMenuComponent_table_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "table", 22)(1, "tbody");
    i0.ɵɵtemplate(2, NotificationsSideMenuComponent_table_17_tr_2_Template, 1, 1, "tr", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.notificationsByCategory[ctx_r2.activeTab]);
} }
function NotificationsSideMenuComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵtext(1, "No new notifications.");
    i0.ɵɵelementEnd();
} }
function NotificationsSideMenuComponent_Conditional_28_For_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "tr", 27);
} if (rf & 2) {
    const report_r5 = ctx.$implicit;
    i0.ɵɵproperty("report", report_r5);
} }
function NotificationsSideMenuComponent_Conditional_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "table", 26)(2, "tbody");
    i0.ɵɵrepeaterCreate(3, NotificationsSideMenuComponent_Conditional_28_For_4_Template, 1, 1, "tr", 27, _forTrack0);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r2.reports);
} }
function NotificationsSideMenuComponent_Conditional_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵtext(1, "No recent downloads. ");
    i0.ɵɵelement(2, "br");
    i0.ɵɵtext(3, " Run a report to see it here.");
    i0.ɵɵelementStart(4, "a", 28);
    i0.ɵɵtext(5, "View all Report History");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("href", ctx_r2.reportHistoryUrl, i0.ɵɵsanitizeUrl);
} }
export class NotificationsSideMenuComponent {
    constructor(notificationsService, complianceReportService, accountsService, urlsService) {
        this.notificationsService = notificationsService;
        this.complianceReportService = complianceReportService;
        this.accountsService = accountsService;
        this.urlsService = urlsService;
        this.topSectionPercentage = model(65, ...(ngDevMode ? [{ debugName: "topSectionPercentage" }] : []));
        this.loading = false;
        this.loadingReports = false;
        this.notifications = model([], ...(ngDevMode ? [{ debugName: "notifications" }] : []));
        this.notificationsByCategory = {
            activity: [],
            todo: [],
        };
        this.activeTab = 'activity';
        this.reportHistoryUrl = '';
        this.complianceReportFetchParams = formFlattenedObject({
            endDate: null,
            reportType: INITIAL_COMPLIANCE_REPORT_TYPE_FILTER_STATE,
            designationType: INITIAL_COMPLIANCE_DESIGNATION_TYPE_FILTER_STATE,
            startDate: null,
            sortColumn: ComplianceReportHistoryPageSortColumn.DOWNLOAD_DATE,
            sortDirection: DESC,
            title: '',
            owner: { me: true, shared_with_me: true },
        }, COMPLIANCE_REPORT_HISTORY_PARAM_KEYS);
        this.reports = [];
        this.isDragging = false;
        this.MAX_REGION_PERCENT = 85;
        this.MIN_REGION_PERCENT = 15;
        this.reportHistoryUrl = this.urlsService.FOLDERS.MY_YCHARTS_REPORT_HISTORY;
    }
    ngOnInit() {
        this.setNotificationsByCategory();
        this.fetchComplianceReports();
    }
    deleteAllNotifications() {
        this.loading = true;
        this.notificationsService
            .deleteNotifications()
            .pipe(finalize(() => {
            this.loading = false;
        }))
            .subscribe({
            next: () => {
                this.notifications.set([]);
                this.setNotificationsByCategory();
            },
            error: () => { },
        });
    }
    removeNotification(notification) {
        this.notifications.set(this.notifications().filter((n) => n.id !== notification.id));
        this.setNotificationsByCategory();
    }
    selectTab(tabType) {
        this.activeTab = tabType;
    }
    setNotificationsByCategory() {
        this.notificationsByCategory = this.notifications().reduce((acc, notification) => {
            const category = TODO_NOTIFICATION_TYPES.has(notification.type) ? 'todo' : 'activity';
            acc[category].push(notification);
            return acc;
        }, { activity: [], todo: [] });
    }
    fetchComplianceReports() {
        this.loadingReports = true;
        this.complianceReportService
            .getComplianceReports({ ...this.complianceReportFetchParams, page: 1 })
            .pipe(finalize(() => {
            this.loadingReports = false;
        }))
            .subscribe({
            next: (rsp) => {
                this.reports = rsp.data.items.slice(0, 7);
            },
            error: () => { },
        });
    }
    onPointerDown(event) {
        event.preventDefault();
        this.isDragging = true;
        event.target.setPointerCapture(event.pointerId);
    }
    onPointerMove(event) {
        if (!this.isDragging)
            return;
        const containerRect = this.regionsContainer.nativeElement.getBoundingClientRect();
        const newTopSectionPercentage = Math.min(this.MAX_REGION_PERCENT, Math.max(this.MIN_REGION_PERCENT, ((event.clientY - containerRect.top) / containerRect.height) * 100));
        this.topSectionPercentage.set(newTopSectionPercentage);
    }
    onPointerUp(event) {
        if (!this.isDragging)
            return;
        this.isDragging = false;
        this.accountsService
            .putUserPreferences({ side_menu_top_section_percentage: this.topSectionPercentage() })
            .subscribe();
        event.target.releasePointerCapture(event.pointerId);
    }
}
NotificationsSideMenuComponent.ɵfac = function NotificationsSideMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || NotificationsSideMenuComponent)(i0.ɵɵdirectiveInject(i1.NotificationsService), i0.ɵɵdirectiveInject(i2.ComplianceReportService), i0.ɵɵdirectiveInject(i3.AccountsService), i0.ɵɵdirectiveInject(i4.UrlsService)); };
NotificationsSideMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationsSideMenuComponent, selectors: [["ycn-notifications-side-menu"]], viewQuery: function NotificationsSideMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.regionsContainer = _t.first);
    } }, inputs: { topSectionPercentage: [1, "topSectionPercentage"], notifications: [1, "notifications"] }, outputs: { topSectionPercentage: "topSectionPercentageChange", notifications: "notificationsChange" }, standalone: false, decls: 30, vars: 19, consts: [["regionsContainer", ""], [1, "regions"], [1, "region", "region-top", 3, "ngStyle"], [1, "region-header"], [1, "region-tabs"], ["data-test-id", "todo-tab", 1, "region-tab-link", 3, "click", "ngClass"], [1, "bullet", "bullet-2"], ["data-test-id", "activity-tab", 1, "region-tab-link", 3, "click", "ngClass"], [1, "bullet", "bullet-15"], [1, "region-body"], [1, "overflow-shadow-y", "height-full", "scrolled-top"], [1, "overflow-shadow-inner", "height-full"], [1, "notifications-body", "panel-content"], ["data-test-id", "notifications-table", "class", "table table-airy table-hover mb-1", 4, "ngIf"], ["data-test-id", "notifications-empty-state", "class", "notifications-empty", 4, "ngIf"], [1, "region-drawer", 3, "pointerdown", "pointermove", "pointerup"], [1, "region", "region-bottom"], [1, "region-header", "border-b", "border-color-gray-80", "pl-12", "pr-12"], [1, "d-flex", "justify-content-between", "align-items-center", "pt-12", "pb-12"], ["tooltip", "View All Report History", "tooltip-placement", "right", 1, "text-bold", "text-underline", 3, "href"], [1, "overflow-shadow-y", "height-full"], [1, "notifications-empty"], ["data-test-id", "notifications-table", 1, "table", "table-airy", "table-hover", "mb-1"], ["ycn-notifications-menu-list-item", "", 3, "notification", "removeNotification", 4, "ngFor", "ngForOf"], ["ycn-notifications-menu-list-item", "", 3, "removeNotification", "notification"], ["data-test-id", "notifications-empty-state", 1, "notifications-empty"], [1, "table", "table-airy", "table-hover", "mb-1"], ["ycn-notifications-menu-report-history-item", "", 3, "report"], [1, "text-underline", "mt-2", 3, "href"]], template: function NotificationsSideMenuComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 1, 0)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5);
        i0.ɵɵlistener("click", function NotificationsSideMenuComponent_Template_div_click_5_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectTab("todo")); });
        i0.ɵɵelement(6, "div", 6);
        i0.ɵɵelementStart(7, "span");
        i0.ɵɵtext(8, "To Do");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵlistener("click", function NotificationsSideMenuComponent_Template_div_click_9_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectTab("activity")); });
        i0.ɵɵelement(10, "div", 8);
        i0.ɵɵelementStart(11, "span");
        i0.ɵɵtext(12, "Activity");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(13, "div", 9)(14, "div", 10)(15, "div", 11)(16, "div", 12);
        i0.ɵɵtemplate(17, NotificationsSideMenuComponent_table_17_Template, 3, 1, "table", 13)(18, NotificationsSideMenuComponent_div_18_Template, 2, 0, "div", 14);
        i0.ɵɵelementEnd()()()()();
        i0.ɵɵelementStart(19, "div", 15);
        i0.ɵɵlistener("pointerdown", function NotificationsSideMenuComponent_Template_div_pointerdown_19_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onPointerDown($event)); })("pointermove", function NotificationsSideMenuComponent_Template_div_pointermove_19_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onPointerMove($event)); })("pointerup", function NotificationsSideMenuComponent_Template_div_pointerup_19_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onPointerUp($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 16)(21, "div", 17)(22, "div", 18)(23, "a", 19);
        i0.ɵɵtext(24, "Report History");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(25, "div", 9)(26, "div", 20)(27, "div", 11);
        i0.ɵɵconditionalCreate(28, NotificationsSideMenuComponent_Conditional_28_Template, 5, 0, "div", 12)(29, NotificationsSideMenuComponent_Conditional_29_Template, 6, 1, "div", 21);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵclassProp("is-dragging", ctx.isDragging);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(11, _c1, "0 0 " + ctx.topSectionPercentage() + "%"));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(13, _c2, ctx.activeTab == "todo"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c2, ctx.activeTab == "activity"));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", (ctx.notificationsByCategory[ctx.activeTab] ?? i0.ɵɵpureFunction0(17, _c3)).length);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !(ctx.notificationsByCategory[ctx.activeTab] ?? i0.ɵɵpureFunction0(18, _c3)).length);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("flex", "1 1 auto");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("href", ctx.reportHistoryUrl, i0.ɵɵsanitizeUrl);
        i0.ɵɵadvance(5);
        i0.ɵɵconditional(ctx.reports.length ? 28 : !ctx.loadingReports ? 29 : -1);
    } }, dependencies: [i5.NgClass, i5.NgForOf, i5.NgIf, i5.NgStyle, i6.NotificationsMenuListItemComponent, i7.NotificationsMenuReportHistoryItemComponent], encapsulation: 2 });
